import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AbstractHttpService } from './abstract-http-service';
import {ConversionEngineSettings} from '../model/conversion-engine-settings.model';

@Injectable({
  providedIn: 'root'
})
export class ConversionEngineSettingsService extends AbstractHttpService {
  defaultOptions = {
    headers: this.contentTypeJsonHeaders,
    withCredentials: true
  };

  constructor(private httpClient: HttpClient) {
    super();
  }

  getSettings(accountId: number): Observable<ConversionEngineSettings> {
    return this.httpClient.get<ConversionEngineSettings>(
      `//${environment.autoDomain}:${environment.autoPort}/api/conversion-engine/${accountId}`,
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );
  }

  updateSettings(settings: ConversionEngineSettings): Observable<any> {
    return this.httpClient.put(
      `//${environment.autoDomain}:${environment.autoPort}/api/conversion-engine`,
      settings,
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );
  }
}
